import React from "react";
import { Tag } from "antd";
import { sortToUserFriendly } from "./constants";

const SortingTag = ({ sorter, columnNames, sortingSeparator = ":", onRemove }) => {
  if (!sorter) {
    return null;
  }

  const sortParts = sorter.split(sortingSeparator);
  const sortKey = sortParts[0];
  const sortValue = sortParts[1];

  return (
    <Tag style={{ borderColor: "silver", maxHeight: 25, marginBottom: 10 }} key={sortKey} closable onClose={onRemove}>
      <span>
        <span style={{ fontWeight: "bold", color: "black" }}>{`${columnNames[sortKey]}:`} </span>

        <span>{`${sortToUserFriendly[sortValue] || sortValue}`} </span>
      </span>
    </Tag>
  );
};

export default SortingTag;
